"use strict";
$(function ($) {

    // ハンバーガーメニュー
    $('#js-hamburger').on('click',function(){
      if($('#js-hamburger').hasClass('is-openSP')){
        $('#js-drawer-menu,#js-hamburger').removeClass('is-openSP');
      }else{
        $('#js-drawer-menu,#js-hamburger').addClass('is-openSP');
      }
    });
  
    // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
    $('#js-drawer-menu a[href]').on('click', function() {
      $('#js-hamburger').trigger('click');
    });
  
    // ハンバーガーメニュー開いている時のスクロールを禁止する
    let state = false;
    let pos;
    $('#js-hamburger').on('click', function(){
      if (state == false) {
        pos = $(window).scrollTop();
        $('body').addClass('js-fixed').css({'top': -pos});
        state = true;
      } else {
        $('body').removeClass('js-fixed').css({'top': 0});
        window.scrollTo(0, pos);
        state = false;
      }
    });

    let mySwiper = new Swiper('.swiper', {
      // /オプション設定
    
      loop: true, // スライド無限ループ
      speed: 1000, // スライドアニメーション速度（ミリ秒）
      effect: 'slide', //スライドの動きエフェクト
      slidesPerView: 1, // 画像の表示枚数
    
      autoplay: { // スライド自動再生
        delay: 2500, // スライド間の遷移遅延時間(ミリ秒)
      },

      navigation: { // ナビゲーション
        nextEl: '.swiper-button-next', // 「次へボタン」要素指定
        prevEl: '.swiper-button-prev', // 「前へボタン」要素指定
      },
    
      breakpoints: { // ブレイクポイント    
        780: { // 画面幅768px以上で適用       
          slidesPerView: 3,
          spaceBetween: 40,
        }
      },
    });

    // アコーディオン
$(document).ready(function() {
  $('.qa__item').click(function() {
    let container = $(this).find('.qa__container');

    // アニメーションの追加・削除
    container.toggleClass('js-qa-container');

    // アニメーションが追加されたら一定時間後に削除
    if (container.hasClass('js-qa-container')) {
      setTimeout(function() {
        container.removeClass('js-qa-container');
      }, 499);
    }
  });
});

// タブメニュー
$(function(){
  $('.works__nav-link').click(function(){
    var tabId = $(this).attr('data-tab');
    
    $('.works__nav-link').removeClass('active');
    $('.works__tab-condent').removeClass('active');
    
    $(this).addClass('active');
    $('#'+tabId).addClass('active');
  });
});

// ふわっと出す
window.addEventListener('scroll', ()=> {
  let jsFadeElements = document.querySelectorAll('.js-fade');
  jsFadeElements.forEach(function (element) {
      let pos = element.offsetTop;
      let scroll = window.scrollY;
      let windowHeight = window.innerHeight;
      if (scroll > pos - windowHeight + 200) {
          if (!element.classList.contains('fade-up')) {
              element.classList.add('fade-up');
          }
      } else {
          element.classList.remove('fade-up');
      }
  });
});

// スクロールしてkeyfarame
$(document).ready(function() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if ($(entry.target).hasClass('bg__slide-r')) {
          $(entry.target).addClass('show-r');
        } else if ($(entry.target).hasClass('bg__slide-l')) {
          $(entry.target).addClass('show-l');
        }
      }
    });
  });

  $('.bg__slide-r').each(function() {
    observer.observe(this);
  });

  $('.bg__slide-l').each(function() {
    observer.observe(this);
  });
});

      // topへ戻る
      const floating = $('#js-pagetop');
      floating.hide();
      $(window).on('scroll', function() {
        if ($(this).scrollTop() > 70) {
          floating.fadeIn();
        } else {
          floating.fadeOut();
        }
      });

});

